module.exports = __webpack_public_path__ + "static/media/avatar-1.4eab68f5.jpg";